import { combineReducers } from 'redux';

import { dashboard } from '@breezeway/brzw-react-core';

export default combineReducers({
  date: dashboard.reducersV2.date,
  filterCounts: dashboard.reducersV2.filterCounts,
  filters: dashboard.reducersV2.filters,
  mapFilters: dashboard.reducersV2.mapFilters,
  mapPeople: dashboard.reducersV2.mapPeople,
  mapPeopleTasks: dashboard.reducersV2.mapPeopleTasks,
  mapProperties: dashboard.reducersV2.mapProperties,
  mapPropertiesTasks: dashboard.reducersV2.mapPropertiesTasks,
  properties: dashboard.reducersV2.properties,
  status: dashboard.reducersV2.status,
  statuses: dashboard.reducersV2.statuses,
});
